import React, { Component } from "react";
import StatusPanel from "../../shared/notices/StatusPanel";
import styles from "../../../assets/css/modules/claims/invoice-cell.css";
import Store from "../../../content/Store";
import Contentify from "../../../content/Contentify";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";

export class InvoiceCell extends Component {
  static content = Store.ClaimDetails.invoiceCell;
  render() {
    const content = this.props.content;
    const invoice = this.props.invoice;
    return (
      <div className={styles.invoiceCell}>
        <h3 id="date">{invoice.InvoiceDate}</h3>
        <p id="providerName">
          {invoice.TreatingProviderName ? (
            content.providerNameLabel + invoice.TreatingProviderName
          ) : (
            <span>{content.noProviderName}</span>
          )}
        </p>
        <p id="providerRef">
          {content.providerRefLabel + invoice.ProviderInvoiceReference}
        </p>
        <p className="mb-2" id="invoiceRef">
          {content.ourRefLabel + invoice.PartialInvoiceReference}
        </p>
        <div
          className={styles.statusPanelWrapper}
          onClick={() => {
            this.props.statusPanelOnClick();
          }}
          onKeyPress={(e) => {
            handleKeyPress(e, this.props.statusPanelOnClick);
          }}
        >
          <StatusPanel
            text={
              invoice.IsPaymentNeededByMember
                ? content.paymentNeededStatus
                : content.costCoveredStatus
            }
            statusColour={invoice.IsPaymentNeededByMember ? "red" : "green"}
          />
        </div>
      </div>
    );
  }
}

export default Contentify(InvoiceCell);
